import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const RECENT_BUYERS = [{
  name: 'Ana',
  city: 'Buenos Aires'
}, {
  name: 'Laura',
  city: 'Córdoba'
}, {
  name: 'María',
  city: 'Rosario'
}, {
  name: 'Sofía',
  city: 'Mendoza'
}, {
  name: 'Elena',
  city: 'Mar del Plata'
}, {
  name: 'Patricia',
  city: 'La Plata'
}, {
  name: 'Gabriela',
  city: 'Tucumán'
}, {
  name: 'Silvia',
  city: 'Neuquén'
}];
export const SalesPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState(RECENT_BUYERS[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Loop to show/hide popup
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = RECENT_BUYERS[Math.floor(Math.random() * RECENT_BUYERS.length)];
        setBuyer(randomBuyer);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000); // Change every 15s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up max-w-[300px] md:max-w-sm" data-id="element-5">
      <div className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-green-500 flex items-center gap-4" data-id="element-6">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-7">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-8" />
        </div>
        <div data-id="element-9">
          <p className="text-sm font-bold text-gray-800" data-id="element-10">
            {buyer.name} de {buyer.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-11">acaba de comprar el Megapack</p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-12">Hace unos instantes</p>
        </div>
      </div>
    </div>;
};